import type { Action } from 'vuex'
import type { Params, State } from './state'
import type {
  QueryDirectFileListModel,
} from '@/api/direct_send/model/sendDirectModel'

import actionTypes from './actionTypes'
import { queryDirectFileList } from '@/api/direct_send/direct_send'

const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_DIRECT_SEND_DETAIL]: async ({ commit, state }): Promise<void> => {
    // リストを取得
    const result: QueryDirectFileListModel | undefined =
      await queryDirectFileList(state.params)
    
    commit(actionTypes.SET_DIRECT_SEND_DETAIL, result?.detail ?? [])
    commit(actionTypes.SET_TOTAL_COUNT, result?.total_count ?? 0)
    commit(actionTypes.SET_CORPORATE_NAME, result?.corporate_name ?? '')
  },

  [actionTypes.SET_PARAMS]: ({ commit }, params: Params): void => {
    commit(actionTypes.SET_PARAMS, params)
  },

  [actionTypes.SET_DIRECT_SEND_CHOOSED_DETAIL]: ({ commit }, data: Array<any>): void => {
    commit(actionTypes.SET_DIRECT_SEND_CHOOSED_DETAIL, data)
  },
}

export default actions
